import MainLayout from "../../../commons/layout/MainLayout";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import ButtonComponent from "../../../commons/components/Forms/ButtonComponent";
import * as videoAction from '../redux/actions';
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import axios from "axios";
import { useUser } from "../../../commons/customHooks/Account";

type Props = {
  footerShow: Boolean
}
const VideoCompletedComponent = ({footerShow}:Props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [loadingMergeVideo, setLoadingMergeVideo] = useState(true);
  const handleLeftClick = () => {
    if (!loadingMergeVideo) {
      dispatch(videoAction.resetVideoRender());
      navigate(ROUTERS.HOME);
    }
  }

  console.log(22, location, 'location');

  useEffect(() => {
    console.log(26, location.state.dataMerge);
    if (location.state.dataMerge?.video_id) {
      getAudioVideo(location.state.dataMerge);
    }
  }, [location.state.dataMerge])

  const getAudioVideo = async (data) => {
    console.log(192, data.name, data.template, data.character);
    try {
      let dataAudioVideo = {
        name: data.name,
        template: data.template,
        character: data.character,
      }
      let url = `${process.env.REACT_APP_VIDEO_SERVER_URL}/process-audio-video`;
      console.log(url, 'REACT_APP_VIDEO_SERVER_URL');

      await axios.get(url, { params: dataAudioVideo }).then(function (response) {
        console.log(202, response);
        if (response.status === 200) {
          let dataMergeVideo = {
            ...response.data,
            video_id: data?.video_id || null,
            user_id: data?.user_id || null
          }
          console.log(208, dataMergeVideo);
          window.nativeCallMergeVideo(dataMergeVideo);
          // dispatch(videoPaymentClearState());
        }else{
          console.log('api faild');
          window.callUploadVideoStatus(false);
        }
      })
      .catch(err => {
        console.log(199, err);
        window.callUploadVideoStatus(false);
      })
    } catch (error) {
      console.log(202, error);
    }
  }

  window.callUploadVideoStatus = function (data) {
    console.log(478, data);
    setLoadingMergeVideo(false);
    // xử lí
    dispatch(videoAction.videoPaymentClearState());
  }


  //dataMerge
  return (
    <MainLayout
      pageID={'video-completed'}
      activeNav={'VIDEO'}
      displayBottomNav={false}
    >
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="결제 완료"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div className="content-completed">
          <div className="image">
            <img src="/images/video_finish.svg" alt="" />
          </div>
          <div className="content-completed__box">
              <h2>영상편지 결제완료!</h2>
              <div className="note">
                <span>영상을 제작 중입니다.</span><br />
                <span>앱을 종료하지 마시고</span><br />
                <span>조금만 기다려 주시기 바랍니다.</span><br />
              </div>
          </div>
          <div className="button">
            <ButtonComponent
              label={`홈으로`}
              cssClass="btn btn-default btn-video-completed"
              handleClick={() => handleLeftClick()}
              type={`button`}
              disabled={loadingMergeVideo}
            />
          </div>
      </div>
    </MainLayout>
  )
}

export default VideoCompletedComponent;